import apiClient from "@shared/services/apiClient";
import type { TrialBanner } from "@shared/types/trialBanner";

export interface OrganizationCommercialState {
  plan_tier?: string | null;
  entitlement_version?: string | null;
  billing_status?: string | null;
  managed_by?: string | null;
  trial_banner?: TrialBanner | null;
}

export async function fetchOrganizationCommercialState(
  orgId: string,
): Promise<OrganizationCommercialState | null> {
  const response = await apiClient.get(`/organizations/${orgId}/commercial`);
  return (response?.data?.data || response?.data || null) as OrganizationCommercialState | null;
}

export async function fetchTrialBanner(
  orgId: string,
): Promise<TrialBanner | null> {
  const payload = await fetchOrganizationCommercialState(orgId);
  return (payload?.trial_banner || null) as TrialBanner | null;
}

